import { useGebruikerContext } from "Pages/Coordinator/Gebruikers/Context/GebruikerContext";
import { useContext, createContext, useState, useEffect, useCallback } from "react";
import { useUpdateGymStatus } from "Api/Coordinator/Gebruikers/Common/Functies";
import { useFunctiesData } from "Api/Coordinator/Gebruikers/GebruikerView/Functies";

export const FunctiesContext = createContext();

export const useFunctiesContext = () => {
	const context = useContext(FunctiesContext);

	if (!context) {
		throw new Error("Use functies context within provider.");
	}

	return context;
};

export const FunctiesProvider = ({ children }) => {
	const { filterCommunity, currentUser } = useGebruikerContext();

	const [gymnastiekValue, setGymnastiekValue] = useState("");

	const communityId = filterCommunity?.[0]?.iCommunityId;
	const adminId = currentUser?.data?.clooserId;

	const {
		trigger: getFunctiesData,
		data: functiesResponse,
		isMutating: isLoading,
	} = useFunctiesData(adminId);

	const refreshFunctiesData = useCallback(async () => {
		if (!communityId || !adminId) {
			return;
		}

		try {
			return await getFunctiesData({
				data: {
					iCommunityId: String(communityId),
				},
			});
		} catch (error) {
			console.error("Failed to refresh functies:", error);
		}
	}, [communityId, adminId, getFunctiesData]);

	
	useEffect(() => {
		refreshFunctiesData();
	}, [refreshFunctiesData]);

	const functiesData = functiesResponse?.data?.functieLists;

	useEffect(() => {
		if (functiesData?.eGym !== undefined) {
			setGymnastiekValue(functiesData.eGym);
		}
	}, [functiesData]);

	const { trigger: updateGebruiker } = useUpdateGymStatus();

	const updateGymnastiekValue = async (value) => {
		if (!adminId) {
			return;
		}

		const payload = {
			iAdminId: adminId,
			attr: "eGym",
			eGym: value,
		};

		try {
			const response = await updateGebruiker({
				data: payload,
			});

			if (response?.status) {
				setGymnastiekValue(value);

				// Call functies API again
				await refreshFunctiesData();
			}
		} catch (error) {
			console.error("API error:", error);
		}
	};

	return (
		<FunctiesContext.Provider
			value={{
				functiesData,
				refreshFunctiesData,
				isLoading,
				gymnastiekValue,
				setGymnastiekValue,
				updateGymnastiekValue,
			}}
		>
			{children}
		</FunctiesContext.Provider>
	);
};